module.exports = __webpack_public_path__ + "b.no2.a5f1c25a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/b.no2.jpg
// module id = dKbs
// module chunks = 0